import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../../../../Constants";
import NavHeightAdjust from "../../../../../../components/navbar/NavHeightAdjust";

const ViewBuildingRecords = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [editEnabled, setEditEnabled] = useState(false);
  const [formData, setFormData] = useState({});
  const [buildingData, setBuildingData] = useState("");
  useEffect(() => {
    const fetchBuilding = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/admin/buildings/${location.state.buildingId}`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const buildingData = await response.json();
        setBuildingData(buildingData);
        if (buildingData.addressID) {
          fetchAddress(buildingData.addressID);
        }
      } catch (error) {
        console.error("Fetch error: ", error);
      }
    };

    const fetchAddress = async (addressID) => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/addresses/${addressID}`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const addressData = await response.json();
        setBuildingData((prevData) => ({
          ...prevData,
          buildingSiteAddress: addressData.physicalStreet1,
        }));
      } catch (error) {
        console.error("Fetch error: ", error);
      }
    };
    fetchBuilding();
  }, []);

  const serviceLaborFields = [
    { key: "maintenanceBilled", label: "Maintenance Billed" },
    { key: "maintenanceLaborCost", label: "Maintenance Labor Cost" },
    { key: "laborNotBilled", label: "Service Labor Not Billed" },
    { key: "maintenanceMaterials", label: "Maintenance Materials" },
    { key: "materialsNotBilled", label: "Service Materials Not Billed" },
  ];

  const carTotals = [
    { key: "totalCars", label: "Car Total" },
    { key: "maintenancePerformed", label: "Maintenance Performed" },
    { key: "maintenanceNotPerformed", label: "Maintenance Not Performed" },
  ];

  const serviceFields = [
    { key: "serviceBilled", label: "Service Billed" },
    { key: "serviceLaborCost", label: "Service Labor Cost" },
    { key: "serviceMaterials", label: "Service Materials" },
  ];

  const laborHoursFields = [
    { key: "maintenanceHours", label: "Maintenance Hours" },
    { key: "maintenanceManHours", label: "Maintenance Man Hours" },
    { key: "serviceHours", label: "Service Hours" },
    { key: "serviceHoursBilled", label: "Service Hours Billed" },
    { key: "manHoursBilled", label: "Man Hours Billed" },
    { key: "serviceHoursNotBilled", label: "Service Hours Not Billed" },
    { key: "manHoursNotBilled", label: "Man Hours Not Billed" },
  ];

  const handleEdit = () => {
    setEditEnabled(() => !editEnabled);
  };

  const handleNavigate = () => {
    navigate(`/setup/building`);
  };

  const renderFields = (fields) => {
    return (
      <table className="table-auto border-collapse border-2 w-full">
        <thead>
          <tr>
            <th></th>
            <th className="border col-start-2 p-2 text-left text-gray-400 font-semibold">
              Standard
            </th>
            <th className="border col-start-3 p-2 text-left text-gray-400 font-semibold">
              STND / CAR
            </th>
          </tr>
        </thead>
        <tbody>
          {fields.map((field) => (
            <tr key={field.key}>
              <td className="border p-2 text-gray-400 font-semibold w-[40%]">
                {field.label}
              </td>
              <td className="border p-2 w-[40%]">
                {/* When backend set up, change input value and h3 content to field data*/}
                {editEnabled ? (
                  <input
                    type="text"
                    name={field.key}
                    className="field w-full p-2 border rounded"
                    placeholder={field.label}
                  />
                ) : (
                  <h3
                    name={field.key}
                    className="field w-full p-2 rounded"
                    placeholder={field.label}
                  >
                    {field.key}
                  </h3>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const renderTimeFields = (fields) => {
    return (
      <table className="table-auto border-collapse border-2 w-full">
        <thead>
          <tr>
            <th></th>
            <th className="border col-start-2 p-2 text-left text-gray-400 font-semibold">
              Regular
            </th>
            <th className="border col-start-3 p-2 text-left text-gray-400 font-semibold">
              Overtime
            </th>
          </tr>
        </thead>
        <tbody>
          {fields.map((field) => (
            <tr key={field.key}>
              <td className="border p-2 text-gray-400 font-semibold w-[40%]">
                {field.label}
              </td>
              <td className="border p-2 w-[40%]">
                {/* When backend set up, change input value and h3 content to field data*/}
                {editEnabled ? (
                  <input
                    type="text"
                    name={field.key}
                    className="field w-full p-2 border rounded"
                    placeholder={field.label}
                  />
                ) : (
                  <h3
                    name={field.key}
                    className="field w-full p-2 rounded"
                    placeholder={field.label}
                  >
                    {field.key}
                  </h3>
                )}
              </td>
              <td className="border p-2 w-[40%]">
                {/* When backend set up, change input value and h3 content to field data*/}
                {editEnabled ? (
                  <input
                    type="text"
                    name={field.key}
                    className="field w-full p-2 border rounded"
                    placeholder={field.label}
                  />
                ) : (
                  <h3
                    name={field.key}
                    className="field w-full p-2 rounded"
                    placeholder={field.label}
                  >
                    {field.key}
                  </h3>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const renderCarFields = (fields) => {
    return (
      <table className="table-auto border-collapse border-2 w-full">
        <thead></thead>
        <tbody>
          {fields.map((field) => (
            <tr key={field.key}>
              <td className="border p-2 text-gray-400 font-semibold w-[40%]">
                {field.label}
              </td>
              <td className="border p-2 w-[40%]">
                {/* When backend set up, change input value and h3 content to field data*/}
                {editEnabled ? (
                  <input
                    type="text"
                    name={field.key}
                    className="field w-full p-2 border rounded"
                    placeholder={field.label}
                  />
                ) : (
                  <h3
                    name={field.key}
                    className="field w-full p-2 rounded"
                    placeholder={field.label}
                  >
                    {field.key}
                  </h3>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <NavHeightAdjust>
      <div>
        <div className="grid grid-cols-7 grid-rows-[auto,.25rem,3rem,3rem] p-4">
          <div className="col-span-7 row-start-1 flex items-center my-auto text-center text-lg border-2 border-r-2 font-semibold py-2 w-full">
            <h3 className="min-w-[calc(30%-1rem)] px-3 text-center text-lg text-gray-400 border-r-2 font-semibold">
              From:
            </h3>
            <input type="date" className="border-2 p-1 rounded-md mx-2" />
            <h3 className="min-w-[calc(20%-1rem)] px-3 text-center text-lg text-gray-400 border-r-2 font-semibold">
              To:
            </h3>
            <input type="date" className="border-2 p-1 rounded-md mx-2" />

            <div className="flex ml-64 gap-4">
              <button
                onClick={() => handleEdit()}
                className={`${
                  editEnabled ? "" : "hidden"
                } px-6 py-2 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600`}
              >
                Save
              </button>
              <button
                onClick={() => handleEdit()}
                className={`${
                  editEnabled ? "hidden" : ""
                } px-6 py-2 bg-yellow-500 text-white font-semibold rounded-md hover:bg-yellow-600`}
              >
                Edit
              </button>
            </div>
          </div>

          <div className="col-span-7 row-start-3 flex border-2">
            <button
              onClick={() => handleNavigate(buildingData.buildingID)}
              className="min-w-[calc(30%-1rem)] my-auto px-3 text-center text-lg text-blue-500 cursor-pointer hover:underline border-r-2 font-semibold"
            >
              Building Site:
            </button>
            <div className="w-full flex items-center">
              <h3 className="pl-4">
                {buildingData === "" ? "" : buildingData.buildingSiteAddress}
              </h3>
            </div>
          </div>

          <div className="col-span-7 row-start-4 flex border-2">
            <h3 className="min-w-[calc(30%-1rem)] my-auto px-3 text-center text-lg text-gray-400 border-r-2 font-semibold">
              Current Mechanic:
            </h3>
            <div className="w-full flex items-center">
              {editEnabled ? (
                <input
                  type="text"
                  className="field w-full p-2 border rounded"
                  value={"Mike Dude"}
                />
              ) : (
                <h3 className="field w-full p-4 rounded">Mike</h3>
              )}
            </div>
          </div>
        </div>

        <div className="flex w-full h-auto p-4 gap-2">
          <div className="w-1/2">
            <table className="table-auto border-collapse border w-full table">
              <tbody>
                {renderFields(serviceLaborFields)}
                <table className="w-full table-fixed">
                  <tr>
                    <th className="col-start-1 border p-2 font-semibold w-[40%] text-left">
                      Maintenance Profit (loss)
                    </th>
                    <th className="col-start-2 border p-2 font-semibold w-[40%]">
                      $2342421234
                    </th>
                    <th className="col-start-3 border p-2 font-semibold w-[20%] overflow-hidden">
                      $2342344353
                    </th>
                  </tr>
                </table>
              </tbody>
            </table>
            <table className="table-auto border-collapse border w-full table mt-4">
              <tbody>
                {renderFields(serviceFields)}
                <table className="w-full table-fixed">
                  <tr>
                    <th className="col-start-1 border p-2 font-semibold w-[40%] text-left">
                      Service Profit (loss)
                    </th>
                    <th className="col-start-2 border p-2 font-semibold w-[40%]">
                      $2342421234
                    </th>
                    <th className="col-start-3 border p-2 font-semibold w-[20%] overflow-hidden">
                      $2342344353
                    </th>
                  </tr>
                  <tr>
                    <th className="col-start-1 border p-2 font-semibold w-[40%] text-left">
                      Repair Profit (loss)
                    </th>
                    <th className="col-start-2 border p-2 font-semibold w-[40%]">
                      $2342421234
                    </th>
                  </tr>
                  <tr>
                    <th className="col-start-1 border p-2 font-semibold w-[40%] text-left">
                      Building Profit (loss)
                    </th>
                    <th className="col-start-2 border p-2 font-semibold w-[40%]">
                      $2342421234
                    </th>
                    <th className="col-start-3 border p-2 font-semibold w-[20%] overflow-hidden">
                      $2342344353
                    </th>
                  </tr>
                </table>
              </tbody>
            </table>
          </div>

          <div className="w-1/2 flex flex-col gap-4">
            {renderTimeFields(laborHoursFields)}
            {renderCarFields(carTotals)}
          </div>
        </div>
      </div>
    </NavHeightAdjust>
  );
};

export default ViewBuildingRecords;
